<template>
  <div id="app" v-resize:throttle="onResize">

    <div
      id="mainBackground"
      :class="[
        (home && !legalVisible) ? 'home' : '',
        legalVisible ? 'legal' : '',
      ]"
    >
      <div class="mb-yellow"></div>
      <div class="mb-logo-container">
        <div class="mb-logo"></div>
        <div :class="['mb-logo-characters', (!home || legalVisible) ? 'animate-in' : '']">
        <!-- <template v-show="!home || legalVisible"> -->
          <div class="mb-logo-merbear" ref="mbLogoMerbear"></div>
          <div class="mb-logo-unishark" ref="mbLogoUnishark"></div>
          <div class="mb-logo-steps" ref="mbLogoSteps">
            <div class="mb-logo-step-match-flavours" v-if="quiz"></div>
            <div class="mb-logo-step-better-squished" v-else></div>
          </div>
        <!-- </template> -->
        </div>
      </div>
    </div>
    <transition
      name="fade"
    >
    <!-- <vue-page-transition name="fade"> -->
      <router-view v-if="!legalVisible" />
    <!-- </vue-page-transition> -->
    </transition>
    <div id="footer">
      <div
        class="footer-legal-btn"
        @click="handleLegalBtnClicked"
        v-show="!legalVisible"
      >
        LEGAL
      </div>
    </div>
    <transition
      name="fade">
      <Legal v-show="legalVisible" />
    </transition>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, onUpdated } from '@vue/composition-api';
import resize from 'vue-resize-directive';
import gsap from 'gsap';

import Legal from '@/views/Legal.vue';

const NAMESPACE = '[App]';

export default {
  name: 'App',
  components: {
    Legal,
  },
  directives: {
    resize
  },

  // watch: {
  //
  // },
  setup(props, context) {

    const {
      // $route,
      $store
    } = context.root;

    // console.log($route);
    // console.log($store);
    // console.log($store.user);
    // console.log($store.getters.product);
    // console.log(context.root.$store.state.general.state);

    // Properties
    const home = ref(false);
    const quiz = ref(false);
    const mbLogoCharacterVisible = ref(false);

    const mbLogoMerbear = ref(null);
    const mbLogoUnishark = ref(null);
    const mbLogoSteps = ref(null);

    const legalVisible = computed(() => {
      // return context.root.$store.getters['general/getLegalVisible'];
      return context.root.$store.state.general.legalVisible;
    })

    const mobile = computed(() => {
      return context.root.$store.state.device.mobile;
    })

    // watch([fooRef, barRef], ([foo, bar], [prevFoo, prevBar]) => {
    //
    // })
    // watch([home, legalVisible], ([newHome, newLegalVisible], [prevHome, prevLegalVisible]) => {
    //   if( !newHome || newLegalVisible ) {
    //     if( (newHome !== prevHome) || (newLegalVisible !== prevLegalVisible) ) {
    //
    //     }
    //   }
    //   // if( !home.value || legalVisible.value ) {
    //   //   console.log('animate from home');
    //   //   animateFromHome();
    //   // } else {
    //   //   console.log('animate to home');
    //   //   animateToHome();
    //   // }
    // })


    // Vue Hooks
    onMounted(() => {
      $store.dispatch('general/setDebugLog', 'App starting.', {root:true});

      console.log(NAMESPACE, 'onMounted()');
      console.log(context.root.$store.state.device);
      let mobile = context.root.$store.state.device;

      // alert('innerHeight:' + window.innerHeight + ', innerWidth:' + window.innerWidth);

      initTimeline();

      checkRoute();

      // this.checkMisfitId();
      // console.log(this);
      checkMisfitId();

      $store.dispatch('device/updateMobileState', null, {root:true});

    });

    onUpdated(() => {
      console.log(NAMESPACE, 'onUpdated');
      console.log(context.root.$route.path);

      checkRoute();

      if( !home.value || legalVisible.value ) {
        console.log('animate from home');

        if( mbLogoCharacterVisible.value !== true ) {
          mbLogoCharacterVisible.value = true;
          animateFromHome();
        }
      } else {
        console.log('animate to home');

        if( mbLogoCharacterVisible.value === true ) {
          mbLogoCharacterVisible.value = false;
          animateToHome();
        }
      }
    })

    // Check the route whether it's home or something
    const checkRoute = () => {
      console.log('checkRoute()');
      console.log('path:', context.root.$route.path);
      console.log('name:', context.root.$route.name);

      // $store.dispatch('general/setDebugLog', 'path: '+context.root.$route.path, {root:true});

      if( context.root.$route.path === '/' || context.root.$route.name.toLowerCase() === 'home' ) {
        home.value = true;
      } else {
        home.value = false;
      }

      if( context.root.$route.path === '/quiz' ) {
        quiz.value = true;
      } else {
        quiz.value = false;
      }
    }


    function checkMisfitId() {
      let misfitId = context.root.$route.params.id;


      if( misfitId != null && misfitId != undefined ) {
        // $store.getters.product
        console.log('found misfit from url');

      } else {
        const misfits = $store.getters['product/getMisfits'];
        console.log(misfits);

        let randomId = Math.floor(Math.random()*misfits.length);
        misfitId = misfits[randomId].id;
        // misfitId = 'mer-bear-lemon-black-raspberry';
      }

      console.log('misfitId:', misfitId);
      $store.dispatch('general/setDebugLog', 'misfitId:'+misfitId, {root:true});

      $store.dispatch('user/setQuizMisfitId', misfitId, {root:true});
    }

    // Legal footer
    const handleLegalBtnClicked = () => {
      $store.dispatch('general/setLegalVisible', true, {root:true});
    }

    const onResize = () => {
      $store.dispatch('device/updateMobileState', null, {root:true});
    }

    // Animation
    let animateFromHomeTimeline = null;// = gsap.timeline({paused:true});
    let animateToHomeTimeline = null;// = gsap.timeline({paused:true});

    // tl.to("#id", {x: 100, duration: 1});
    // tl.to("#id", {y: 50, duration: 1});
    // tl.to("#id", {opacity: 0, duration: 1});
    const initTimeline = () => {
      // animateFromHomeTimeline.to('.mb-yellow', {});
    }

    const animateFromHome = () => {
      if( animateToHomeTimeline !== null ) {
        animateToHomeTimeline.pause();
      }

      if( animateFromHomeTimeline === null ) {
        animateFromHomeTimeline = gsap.timeline({paused:true});

        animateFromHomeTimeline.to(mbLogoMerbear.value, {duration:0.3, opacity:1, ease:"sine.out", delay:0.1});
        animateFromHomeTimeline.to(mbLogoUnishark.value, {duration:0.3, opacity:1, ease:"sine.out"}, '-=0.3');
        animateFromHomeTimeline.to(mbLogoSteps.value, {duration:0.3, opacity:1, ease:"sine.out"}, '-=0.3');
      }

      animateFromHomeTimeline.restart();

    }

    const animateToHome = () => {
      if( animateFromHomeTimeline !== null ) {
        animateFromHomeTimeline.pause();
      }

      if( animateToHomeTimeline === null ) {
        animateToHomeTimeline = gsap.timeline({paused:true});

        animateToHomeTimeline.to(mbLogoMerbear.value, {duration:0.1, opacity:0, ease:"sine.in"});
        animateToHomeTimeline.to(mbLogoUnishark.value, {duration:0.1, opacity:0, ease:"sine.in"}, '-=0.1');
        animateToHomeTimeline.to(mbLogoSteps.value, {duration:0.1, opacity:0, ease:"sine.in"}, '-=0.1');
      }

      animateToHomeTimeline.restart();
    }

    const legalBeforeEnter = (el) => {
      console.log(NAMESPACE, 'legalBeforeEnter');
    }

    return {
      home,
      quiz,
      legalVisible,
      mobile,

      mbLogoMerbear,
      mbLogoUnishark,
      mbLogoSteps,

      handleLegalBtnClicked,
      onResize,

      legalBeforeEnter,
    }
  },

}

</script>

<style lang="scss">
#app {
  // font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  // background-color: #900;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  min-height: calc(var(--vh, 1vh) * 100 - 0vh);
  // background-image: url('~@/assets/images/blue_bg.jpg');
  // background-size: cover;
  // background-repeat: no-repeat;
}


#mainBackground {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  // min-height: calc(var(--vh, 1vh) * 100 - 0vh);
  background-image: url('~@/assets/images/blue_bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  overflow-x: hidden;
  overflow-y: hidden;

  &.home {
    .mb-yellow {
      top: -17%;
    }

    .mb-logo {
      // top: 7.5%;
      width: 50%;
    }

    .mb-logo-characters {
      // opacity: 0;
    }
  }

  &.legal {
    .mb-yellow {
      top: -35%;
    }

    .mb-logo {
      width: 26%;
    }

    .mb-logo-characters {
      // opacity: 1;
    }
  }
}

.mb-yellow {
  position: absolute;
  top: -35%;
  left: -25%;
  width: 150%;
  height: 50%;
  background-color: $bg-yellow-color;
  transform: rotate3d(0, 0, 1, -9deg);
  transition: top 0.3s;
}

.mb-logo-container {
  position: absolute;
  top: 4.5%;
  // width: 100%;
  left: 50%;
  transform: translateX(-50%);

  width: 60%;
  max-width: $max-content-view-width * 0.8;

  @include bg-image(310, 100);

  // transition: width 3s, top 0.3s;
  // transition: width 3s;
}

.mb-logo {
  position: absolute;
  // margin: 5.2rem auto 0 auto;
  // top: 4.5%;
  top: 0;
  left: 49%;
  width: 26%;
  background-image: url('~@/assets/images/logo.png');
  background-size: cover;
  background-repeat: no-repeat;
  transform: translateX(-50%);
  transition: width 0.3s;

  @include bg-image(527, 424);
}

.mb-logo-characters {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // opacity: 1;

  transition: opacity 0.2s ease-out 0s;

  &.animate-in {
    transition-delay: 0.1s;
  }
}

.mb-logo-merbear {
  position: absolute;
  top: 5%;
  left: 50%;
  width: 20%;
  margin-top: 2%;
  transform: translateX(-218%);
  background-image: url('~@/assets/images/logo_merbear.png');
  background-size: cover;
  background-repeat: no-repeat;
  @include bg-image(220, 383);

  opacity: 0;
}

.mb-logo-unishark {
  position: absolute;
  top: -15%;
  left: 50%;
  width: 26%;
  transform: translateX(73%);
  background-image: url('~@/assets/images/logo_unishark.png');
  background-size: cover;
  background-repeat: no-repeat;
  @include bg-image(274, 410);

  opacity: 0;
}

.mb-logo-steps {
  position: absolute;
  top: 38%;
  left: 50%;
  width: 70%;
  transform: translateX(-47%);
  @include bg-image(750, 300);

  opacity: 0;
}

.mb-logo-step-match-flavours {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/images/chat_bubble_match_the_flavours.png');
  background-size: cover;
  background-repeat: no-repeat;
}

.mb-logo-step-better-squished {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/images/chat_bubble_better_squished_together.png');
  background-size: cover;
  background-repeat: no-repeat;
}

#footer {
  position: absolute;
  bottom: 1rem;
  width: 100%;
  text-align: center;
}

.footer-legal-btn {
  position: relative;
  display: inline-block;

}

// Animation
.fade-enter-active {
  // animation: fade-in 5s;
  transition: opacity 0.2s, transform 0.25s;
  // transition: opacity 0.5s;
}
.fade-leave-active {
  // animation: fade-out 5s;
  transition: opacity 0.2s, transform 0.25s;
  // transition: opacity 0.5s;
}
.fade-enter {
  opacity: 0;
  transform: translateX(100%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.fade-enter-to, .fade-leave {
  opacity: 1;
  transform: translateX(0);
}



@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateX(30%);
  }
  50% {
    opacity: 0;
    transform: translateX(20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}

@keyframes fade-out {
  0% {
    opacity: 1;
    transform: translateX(0%);
  }
  50% {
    opacity: 1;
    transform: translateX(-20%);
  }
  100% {
    opacity: 0;
    transform: translateX(-30%);
  }
}

@include height-medium {
  #mainBackground {
    &.legal {
      .mb-yellow {
        top: -37%;
      }
    }
  }

  .mb-yellow {
    top: -37%;
  }

  .mb-logo-container {
    top: 2.5%;
    width: 90%;
  }
}

@include height-short {
  #mainBackground {
    &.legal {
      .mb-yellow {
        top: -37%;
      }
    }
  }

  .mb-yellow {
    top: -37%;
  }

  .mb-logo-container {
    top: 3.5%;
    width: 90%;
  }
}

@include mobile {
  #mainBackground {
    &.home {
      .mb-yellow {
        top: -10%;
      }

      .mb-logo {
        width: 40%;
      }
    }

    &.legal {
      .mb-yellow {
        top: -36%;
      }
    }
  }

  .mb-yellow {
    top: -36%;
    // left: -25%;
    // width: 150%;
    // height: 50%;
  }

  .mb-logo-container {
    top: 3%;
    width: 80%;
  }
}

@include mobile-small {
  .mb-yellow {
    top: -36%;
    // left: -25%;
    // width: 150%;
    // height: 50%;
  }

  .mb-logo-container {
    top: 2.5%;
    width: 76%;
  }
}

body.touch {
  @include height-medium {

  }

  @include height-short {
    #mainBackground {
      &.legal {
        .mb-yellow {
          top: -38%;
        }
      }
    }

    .mb-yellow {
      top: -38%;

    }

    .mb-logo-container {
      width: 66%;
    }
  }

  @include mobile-aspect-ratio-40-62 {
    #mainBackground {
      &.legal {
        .mb-yellow {
          top: -38%;
        }
      }
    }

    .mb-yellow {
      top: -38%;
    }

    .mb-logo-container {
      top: 2.5%;
      width: 62%;
    }
  }

  @include mobile-aspect-ratio-40-59 {
    #mainBackground {
      &.legal {
        .mb-yellow {
          top: -39%;
        }
      }
    }

    .mb-yellow {
      top: -39%;
    }

    .mb-logo-container {
      top: 2.5%;
      // width: 58%;
      width: 52%;
    }
  }

}

</style>
